export class ChannelTaskAssignment {
    state: string;
    assignee: string[] = [];

    constructor(state: string) {
        this.state = state;
    }
}
